"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsProvider_1 = require("../AnalyticsProvider");
var injectScriptTag_1 = require("./injectScriptTag");
var FacebookPixelProvider = /** @class */ (function (_super) {
    __extends(FacebookPixelProvider, _super);
    function FacebookPixelProvider(name, config) {
        var _this = _super.call(this, name) || this;
        _this.config = config;
        // If Redline, inject script and init
        if (_this.config.eventCallback === undefined) {
            console.log("Facebook Pixel configured with ID: ".concat(config.pixelId));
            (0, injectScriptTag_1.injectScriptTag)();
            fbq("init", config.pixelId);
        }
        return _this;
    }
    FacebookPixelProvider.prototype.vehicleAdded = function (dealId, vehicle) {
        this.sendEvent("track", "AddToWishlist", this.getTrackingObject(vehicle));
    };
    FacebookPixelProvider.prototype.schedulePickupOrDeliveryFormFinished = function (dealId, vehicle) {
        this.sendEvent("track", "CompleteRegistration", this.getTrackingObject(vehicle));
    };
    FacebookPixelProvider.prototype.paymentCalcInteraction = function (dealId, vehicle) {
        this.sendEvent("track", "CustomizeProduct", this.getTrackingObject(vehicle));
    };
    FacebookPixelProvider.prototype.garageInteraction = function (dealId, vehicle) {
        this.sendEvent("track", "CustomizeProduct", this.getTrackingObject(vehicle));
    };
    FacebookPixelProvider.prototype.continueDeal = function (vin) {
        this.sendEvent("track", "InitiateCheckout", {
            content_type: "vehicle",
            content_ids: ["".concat(vin)], // REQUIRED: array of vehicle IDs
        });
    };
    FacebookPixelProvider.prototype.leadFormFinished = function (dealId, vehicle) {
        this.sendEvent("track", "Lead", this.getTrackingObject(vehicle));
    };
    FacebookPixelProvider.prototype.getTrackingObject = function (vehicle) {
        var _a, _b, _c;
        var mapType = function (type) {
            return {
                "Certified Used": "CPO",
                New: "New",
                Used: "Used",
            }[type];
        };
        return {
            content_type: "vehicle",
            content_ids: ["".concat(vehicle.vin)],
            make: "".concat(vehicle.make),
            model: "".concat(vehicle.model),
            year: "".concat(vehicle.year),
            state_of_vehicle: "".concat(mapType(vehicle.type)),
            price: (_c = (_a = vehicle.payments) === null || _a === void 0 ? void 0 : _a[(_b = vehicle.payments) === null || _b === void 0 ? void 0 : _b.selected]) === null || _c === void 0 ? void 0 : _c.price, // RECOMMENDED, up to 2 decimals optional
        };
    };
    FacebookPixelProvider.prototype.sendEvent = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.config.eventCallback === undefined) {
            fbq.apply(void 0, __spreadArray([], __read(args), false));
            return;
        }
        this.config.eventCallback(this.config.pixelId, args);
    };
    return FacebookPixelProvider;
}(AnalyticsProvider_1.AnalyticsProvider));
exports.default = FacebookPixelProvider;
